import { motion } from "framer-motion";
import { ShieldCheck, FileSignature, Lock, EyeOff } from "lucide-react";

const POINTS = [
  { Icon: FileSignature, title: "NDAs on request", body: "We're happy to sign mutual non-disclosure agreements before any project starts." },
  { Icon: Lock, title: "Secure access", body: "Password managers, role-based logins, and least-privilege access for every team member." },
  { Icon: EyeOff, title: "Confidential by default", body: "Client data is never shared, sold, or used for anything outside your engagement." },
];

export default function Security() {
  return (
    <section id="security" className="relative py-28 lg:py-36 overflow-hidden" data-testid="security-section">
      <div className="container-apex">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="lg:col-span-5"
          >
            <div className="overline">Security & Confidentiality</div>
            <h2 className="heading-display text-4xl sm:text-5xl lg:text-6xl mt-5">
              Your information is <span className="text-[#16A34A]">safe.</span>
            </h2>
            <p className="mt-6 text-muted-foreground text-lg leading-relaxed">
              Admin Apex Business Solutions follows strict confidentiality practices. We can work under Non-Disclosure Agreements (NDAs) and handle your business information with professionalism and discretion.
            </p>

            <div className="mt-8 inline-flex items-center gap-3 px-4 py-3 rounded-xl border border-[#16A34A]/40 bg-[#16A34A]/5 text-sm">
              <ShieldCheck size={18} className="text-[#16A34A]" />
              <span className="font-semibold">NDA-ready engagements · Canadian-operated · Confidential by default</span>
            </div>
          </motion.div>

          <div className="lg:col-span-7 grid sm:grid-cols-3 gap-5">
            {POINTS.map((p, i) => (
              <motion.div
                key={p.title}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08 }}
                className="card-apex p-6"
                data-testid={`security-point-${i}`}
              >
                <div className="w-11 h-11 rounded-xl bg-[#0B2545] text-white flex items-center justify-center">
                  <p.Icon size={18} />
                </div>
                <h3 className="mt-5 font-display font-bold text-lg">{p.title}</h3>
                <p className="mt-2 text-sm text-muted-foreground">{p.body}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
